import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { setRangeValue } from "../../Utils/NumberUtils";
export var ColorAnimation = /*#__PURE__*/function () {
  function ColorAnimation() {
    _classCallCheck(this, ColorAnimation);

    this.count = 0;
    this.enable = false;
    this.offset = 0;
    this.speed = 1;
    this.delay = 0;
    this.decay = 0;
    this.sync = true;
  }

  _createClass(ColorAnimation, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.count !== undefined) {
        this.count = setRangeValue(data.count);
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      if (data.offset !== undefined) {
        this.offset = setRangeValue(data.offset);
      }

      if (data.speed !== undefined) {
        this.speed = setRangeValue(data.speed);
      }

      if (data.decay !== undefined) {
        this.decay = setRangeValue(data.decay);
      }

      if (data.delay !== undefined) {
        this.delay = setRangeValue(data.delay);
      }

      if (data.sync !== undefined) {
        this.sync = data.sync;
      }
    }
  }]);

  return ColorAnimation;
}();